(function () {
  const BRAND_LABELS = {
    meta: 'Meta / Ray-Ban',
    oakley: 'Oakley Meta',
    xreal: 'XREAL',
    rayneo: 'RayNeo',
    rokid: 'Rokid',
    viture: 'VITURE'
  };

  const BRAND_COLLECTION_HANDLES = {
    meta: 'meta-ray-ban',
    oakley: 'oakley',
    xreal: 'xreal',
    rayneo: 'rayneo',
    rokid: 'rokid',
    viture: 'viture'
  };

  const MODEL_LABELS = {
    'wayfarer-large': 'Wayfarer Large',
    wayfarer: 'Wayfarer',
    round: 'Round',
    headliner: 'Headliner',
    skyler: 'Skyler',
    hstn: 'HSTN',
    sphaera: 'Sphaera',
    air: 'Air',
    'air-2': 'Air 2',
    'air-2-pro': 'Air 2 Pro',
    'air-2-ultra': 'Air 2 Ultra',
    x2: 'X2',
    max: 'Max',
    'max-pro': 'Max Pro',
    one: 'One',
    'one-lite': 'One Lite',
    'one-xr': 'One XR',
    pro: 'Pro'
  };

  const FIT_STORAGE_KEY = 'sgg-selected-fit-v1';

  function money(cents) {
    if (typeof cents !== 'number') return '';

    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(cents / 100);
  }

  function normalizeKey(value) {
    return (value || '').trim().toLowerCase();
  }

  function readCsv(value) {
    return (value || '')
      .split(',')
      .map((item) => item.trim())
      .filter(Boolean);
  }

  function getFitParams() {
    const params = new URLSearchParams(window.location.search);

    return {
      brand: normalizeKey(params.get('brand')),
      model: normalizeKey(params.get('model'))
    };
  }

  function normalizeFitSelection(selection) {
    const brand = normalizeKey(selection?.brand);
    const model = normalizeKey(selection?.model);

    if (!brand || !model) return null;

    return {
      brand,
      model,
      brandLabel: (selection?.brandLabel || BRAND_LABELS[brand] || brand).trim(),
      modelLabel: (selection?.modelLabel || MODEL_LABELS[model] || model).trim()
    };
  }

  function getSelectionLabel(selection) {
    const normalized = normalizeFitSelection(selection);
    if (!normalized) return '';
    return `${normalized.brandLabel} ${normalized.modelLabel}`;
  }

  function getStoredFitSelection() {
    try {
      return normalizeFitSelection(JSON.parse(window.localStorage.getItem(FIT_STORAGE_KEY) || 'null'));
    } catch (error) {
      return null;
    }
  }

  function setStoredFitSelection(selection) {
    const normalized = normalizeFitSelection(selection);

    try {
      if (normalized) {
        window.localStorage.setItem(FIT_STORAGE_KEY, JSON.stringify(normalized));
      } else {
        window.localStorage.removeItem(FIT_STORAGE_KEY);
      }
    } catch (error) {
      return normalized;
    }

    return normalized;
  }

  function clearStoredFitSelection() {
    try {
      window.localStorage.removeItem(FIT_STORAGE_KEY);
    } catch (error) {
      return;
    }
  }

  function buildFitCollectionUrl(selection) {
    const normalized = normalizeFitSelection(selection);

    if (!normalized) return '/collections';

    const handle = BRAND_COLLECTION_HANDLES[normalized.brand];

    if (!handle) return '/collections';

    return `/collections/${handle}/model-${normalized.model}`;
  }

  function ensureHiddenInput(form, name, value) {
    form.querySelectorAll(`input[data-sgg-fit-param="${name}"]`).forEach((input) => input.remove());

    if (!value) return;

    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    input.setAttribute('data-sgg-fit-param', name);
    form.appendChild(input);
  }

  function syncFitParamsToForm(form) {
    if (!(form instanceof HTMLFormElement)) return;

    const { brand, model } = getFitParams();
    ensureHiddenInput(form, 'brand', brand);
    ensureHiddenInput(form, 'model', model);
  }

  function preserveFitParamsOnLink(link) {
    if (!(link instanceof HTMLAnchorElement)) return;
    if (!link.href || link.getAttribute('href')?.startsWith('#')) return;

    const { brand, model } = getFitParams();
    if (!brand && !model) return;

    const url = new URL(link.href, window.location.origin);
    if (url.origin !== window.location.origin) return;

    if (brand && !url.searchParams.has('brand')) {
      url.searchParams.set('brand', brand);
    }

    if (model && !url.searchParams.has('model')) {
      url.searchParams.set('model', model);
    }

    link.href = `${url.pathname}${url.search}${url.hash}`;
  }

  function syncFitFilterLinks(selectionOverride) {
    const params = getFitParams();
    const storedSelection = normalizeFitSelection(selectionOverride) || getStoredFitSelection();
    const activeBrand = params.brand || storedSelection?.brand || '';
    const activeModel = params.model || storedSelection?.model || '';

    document.querySelectorAll('[data-sgg-filter-link]').forEach((link) => {
      if (!(link instanceof HTMLElement)) return;

      const linkBrand = link.dataset.brandKey || '';
      const linkModel = link.dataset.modelKey || '';
      const isBrandLink = Boolean(linkBrand) && !linkModel;
      const isModelLink = Boolean(linkBrand) && Boolean(linkModel);
      const isActive =
        (isBrandLink && activeBrand === linkBrand && !activeModel) ||
        (isModelLink && activeBrand === linkBrand && activeModel === linkModel);

      link.classList.toggle('is-active', isActive);

      if (isActive && link instanceof HTMLAnchorElement) {
        const linkUrl = new URL(link.href, window.location.origin);

        if (linkUrl.pathname === window.location.pathname) {
          link.setAttribute('aria-current', 'page');
        } else {
          link.removeAttribute('aria-current');
        }
      } else if (isActive) {
        link.setAttribute('aria-current', 'page');
      } else {
        link.removeAttribute('aria-current');
      }
    });

    document.querySelectorAll('[data-sgg-model-nav-group]').forEach((group) => {
      if (!(group instanceof HTMLElement)) return;

      const trigger = group.querySelector('[data-sgg-model-trigger]');
      const matchingModel = group.querySelector('[data-sgg-filter-link][data-model-key].is-active');
      const matchingBrand = group.querySelector('[data-sgg-filter-link][data-brand-key]:not([data-model-key]).is-active');
      const shouldHighlight = Boolean(matchingModel || matchingBrand);

      if (trigger instanceof HTMLElement) {
        trigger.classList.toggle('is-active', shouldHighlight);
      }
    });
  }

  function buildFitLabel(params) {
    const brandLabel = BRAND_LABELS[params.brand] || '';
    const modelLabel = MODEL_LABELS[params.model] || '';

    if (brandLabel && modelLabel) {
      return `${brandLabel} ${modelLabel}`;
    }

    return brandLabel || modelLabel;
  }

  function makeFilterLink(url, text) {
    const link = document.createElement('a');
    link.className = 'sgg-active-filter';
    link.href = url;
    link.textContent = text;
    return link;
  }

  function renderFitFilterSummary(container, params) {
    if (!(container instanceof HTMLElement)) return;

    const { brand, model } = params;
    container.innerHTML = '';

    if (!brand && !model) {
      container.hidden = true;
      return;
    }

    const currentUrl = new URL(window.location.href);

    if (brand) {
      const brandUrl = new URL(currentUrl.toString());
      brandUrl.searchParams.delete('brand');
      brandUrl.searchParams.delete('model');

      const brandLink = makeFilterLink(
        `${brandUrl.pathname}${brandUrl.search}${brandUrl.hash}`,
        `Brand: ${BRAND_LABELS[brand] || brand}`
      );
      brandLink.appendChild(document.createElement('span')).textContent = 'x';
      container.appendChild(brandLink);
    }

    if (model) {
      const modelUrl = new URL(currentUrl.toString());
      modelUrl.searchParams.delete('model');

      const modelLink = makeFilterLink(
        `${modelUrl.pathname}${modelUrl.search}${modelUrl.hash}`,
        `Model: ${MODEL_LABELS[model] || model}`
      );
      modelLink.appendChild(document.createElement('span')).textContent = 'x';
      container.appendChild(modelLink);
    }

    const clearLink = document.createElement('a');
    clearLink.className = 'sgg-active-filter sgg-active-filter--clear';
    const clearUrl = new URL(currentUrl.toString());
    clearUrl.searchParams.delete('brand');
    clearUrl.searchParams.delete('model');
    clearLink.href = `${clearUrl.pathname}${clearUrl.search}${clearUrl.hash}`;
    clearLink.textContent = 'Clear fit filter';
    container.appendChild(clearLink);

    container.hidden = false;
  }

  function updateResultsLabel(node, visibleCount, params) {
    if (!(node instanceof HTMLElement)) return;

    const label = buildFitLabel(params);
    const productCopy = `${visibleCount} product${visibleCount === 1 ? '' : 's'}`;
    node.textContent = label ? `${productCopy} for ${label}` : productCopy;
  }

  function getCollectionContextSelection(root) {
    if (!(root instanceof HTMLElement)) return null;

    return normalizeFitSelection({
      brand: root.dataset.sggCurrentBrand,
      model: root.dataset.sggCurrentModel,
      brandLabel: root.dataset.sggCurrentBrandLabel,
      modelLabel: root.dataset.sggCurrentModelLabel
    });
  }

  function getFitStateForProduct({ brands, models, universal }, selection) {
    const normalizedSelection = normalizeFitSelection(selection);

    if (!normalizedSelection) {
      return { status: 'empty' };
    }

    const sameBrand = brands.includes(normalizedSelection.brand);
    const sameModel = models.includes(normalizedSelection.model);
    const isUniversalMatch = universal && (brands.length === 0 || sameBrand);

    if (sameBrand && sameModel) {
      return { status: 'fit' };
    }

    if (isUniversalMatch) {
      return { status: 'universal' };
    }

    return { status: 'warning' };
  }

  function renderFitGarage(selection) {
    const normalizedSelection = normalizeFitSelection(selection);

    document.querySelectorAll('[data-sgg-fit-garage]').forEach((garage) => {
      if (!(garage instanceof HTMLElement)) return;

      const labelNode = garage.querySelector('[data-sgg-fit-garage-label]');
      const copyNode = garage.querySelector('[data-sgg-fit-garage-copy]');
      const linkNode = garage.querySelector('[data-sgg-fit-garage-link]');

      if (!normalizedSelection) {
        garage.hidden = true;
        return;
      }

      if (labelNode instanceof HTMLElement) {
        labelNode.textContent = getSelectionLabel(normalizedSelection);
      }

      if (copyNode instanceof HTMLElement) {
        copyNode.textContent = 'Fit checks stay visible while you browse compatible accessories.';
      }

      if (linkNode instanceof HTMLAnchorElement) {
        linkNode.href = buildFitCollectionUrl(normalizedSelection);
        linkNode.textContent = 'Shop this fit';
      }

      garage.hidden = false;
    });
  }

  function renderProductCardFitStates(selection) {
    const normalizedSelection = normalizeFitSelection(selection);

    document.querySelectorAll('[data-sgg-product-card]').forEach((card) => {
      if (!(card instanceof HTMLElement)) return;

      const stateRoot = card.querySelector('[data-sgg-card-fit-state]');
      const badgeNode = card.querySelector('[data-sgg-card-fit-badge]');
      const copyNode = card.querySelector('[data-sgg-card-fit-copy]');

      if (!(stateRoot instanceof HTMLElement) || !(badgeNode instanceof HTMLElement) || !(copyNode instanceof HTMLElement)) {
        return;
      }

      stateRoot.classList.remove('is-fit', 'is-warning', 'is-universal');

      if (!normalizedSelection) {
        stateRoot.hidden = true;
        return;
      }

      const fitState = getFitStateForProduct(
        {
          brands: readCsv(card.dataset.sggBrandKeys),
          models: readCsv(card.dataset.sggModelKeys),
          universal: card.dataset.sggUniversal === 'true'
        },
        normalizedSelection
      );

      const selectionLabel = getSelectionLabel(normalizedSelection);

      if (fitState.status === 'fit') {
        badgeNode.textContent = 'Fits your model';
        copyNode.textContent = selectionLabel;
        stateRoot.classList.add('is-fit');
      } else if (fitState.status === 'universal') {
        badgeNode.textContent = 'Universal fit';
        copyNode.textContent = `Works with ${selectionLabel}`;
        stateRoot.classList.add('is-universal');
      } else {
        badgeNode.textContent = 'Check fit';
        copyNode.textContent = `Saved model: ${selectionLabel}`;
        stateRoot.classList.add('is-warning');
      }

      stateRoot.hidden = false;
    });
  }

  function renderProductFitChecks(selection) {
    const normalizedSelection = normalizeFitSelection(selection);

    document.querySelectorAll('[data-sgg-product-root]').forEach((root) => {
      if (!(root instanceof HTMLElement)) return;

      const panel = root.querySelector('[data-sgg-product-fit-check]');
      const titleNode = root.querySelector('[data-sgg-fit-check-title]');
      const copyNode = root.querySelector('[data-sgg-fit-check-copy]');
      const linkNode = root.querySelector('[data-sgg-fit-check-link]');
      const clearButton = root.querySelector('.sgg-product-fit-check-clear[data-sgg-fit-clear]');

      if (!(panel instanceof HTMLElement) || !(titleNode instanceof HTMLElement) || !(copyNode instanceof HTMLElement)) {
        return;
      }

      const compatibilityText = root.dataset.sggCompatibilityText || 'supported smart glasses models';

      panel.classList.remove('is-fit', 'is-warning', 'is-empty', 'is-universal');

      if (!normalizedSelection) {
        titleNode.textContent = 'Choose your glasses model';
        copyNode.textContent = `Save your exact model and the store will keep compatibility checks visible while you browse. This product is currently tagged for ${compatibilityText}.`;

        if (linkNode instanceof HTMLAnchorElement) {
          linkNode.href = '/collections';
          linkNode.textContent = 'Choose model';
        }

        if (clearButton instanceof HTMLButtonElement) {
          clearButton.hidden = true;
        }

        panel.classList.add('is-empty');
        return;
      }

      const fitState = getFitStateForProduct(
        {
          brands: readCsv(root.dataset.sggBrandKeys),
          models: readCsv(root.dataset.sggModelKeys),
          universal: root.dataset.sggUniversal === 'true'
        },
        normalizedSelection
      );

      const selectionLabel = getSelectionLabel(normalizedSelection);

      if (fitState.status === 'fit') {
        titleNode.textContent = `Fits your ${selectionLabel}`;
        copyNode.textContent = `This product is tagged for ${selectionLabel}, so the saved fit matches what is shown on this page.`;
        panel.classList.add('is-fit');
      } else if (fitState.status === 'universal') {
        titleNode.textContent = `Works with your ${selectionLabel}`;
        copyNode.textContent = `This item is marked as universal fit. Review the supported models listed on the page if you want a second check before ordering.`;
        panel.classList.add('is-universal');
      } else {
        titleNode.textContent = 'Check fit before ordering';
        copyNode.textContent = `Your saved model is ${selectionLabel}. This product is currently tagged for ${compatibilityText}, so confirm compatibility before you add it to cart.`;
        panel.classList.add('is-warning');
      }

      if (linkNode instanceof HTMLAnchorElement) {
        linkNode.href = buildFitCollectionUrl(normalizedSelection);
        linkNode.textContent = `Shop gear for ${normalizedSelection.modelLabel}`;
      }

      if (clearButton instanceof HTMLButtonElement) {
        clearButton.hidden = false;
      }
    });
  }

  function refreshFitUi(selectionOverride) {
    const normalizedSelection = normalizeFitSelection(selectionOverride) || getStoredFitSelection();
    syncFitFilterLinks(normalizedSelection);
    renderFitGarage(normalizedSelection);
    renderProductCardFitStates(normalizedSelection);
    renderProductFitChecks(normalizedSelection);
  }

  function bindFitSelectionTriggers() {
    document.querySelectorAll('[data-sgg-fit-select]').forEach((link) => {
      if (!(link instanceof HTMLElement)) return;

      link.addEventListener('click', () => {
        const selection = normalizeFitSelection({
          brand: link.dataset.brandKey,
          model: link.dataset.modelKey,
          brandLabel: link.dataset.brandLabel,
          modelLabel: link.dataset.modelLabel
        });

        if (!selection) return;

        setStoredFitSelection(selection);
        refreshFitUi(selection);
      });
    });

    document.querySelectorAll('[data-sgg-fit-clear]').forEach((button) => {
      if (!(button instanceof HTMLButtonElement)) return;

      button.addEventListener('click', (event) => {
        event.preventDefault();
        clearStoredFitSelection();
        refreshFitUi(null);
      });
    });
  }

  function initCollectionControls() {
    document.querySelectorAll('[data-sgg-collection-form]').forEach((form) => {
      if (!(form instanceof HTMLFormElement)) return;

      syncFitParamsToForm(form);

      form.addEventListener('submit', () => {
        syncFitParamsToForm(form);
      });

      form.addEventListener('change', (event) => {
        const target = event.target;
        if (!(target instanceof HTMLInputElement)) return;

        if (target.type === 'checkbox' || target.type === 'radio') {
          syncFitParamsToForm(form);
          form.requestSubmit();
        }
      });
    });

    document.querySelectorAll('[data-sgg-sort-form] select').forEach((select) => {
      if (!(select instanceof HTMLSelectElement)) return;

      syncFitParamsToForm(select.form);

      select.addEventListener('change', () => {
        syncFitParamsToForm(select.form);
        select.form?.requestSubmit();
      });
    });

    document.querySelectorAll('[data-sgg-preserve-fit]').forEach((link) => {
      preserveFitParamsOnLink(link);
    });
  }

  function initModelRail() {
    const groups = Array.from(document.querySelectorAll('[data-sgg-model-nav-group]'));

    if (!groups.length) return;

    function closeGroup(group) {
      if (!(group instanceof HTMLElement)) return;

      group.classList.remove('is-open');
      const trigger = group.querySelector('[data-sgg-model-trigger]');
      if (trigger instanceof HTMLButtonElement) {
        trigger.setAttribute('aria-expanded', 'false');
      }
    }

    function openGroup(group) {
      if (!(group instanceof HTMLElement)) return;

      groups.forEach((candidate) => {
        if (candidate !== group) {
          closeGroup(candidate);
        }
      });

      group.classList.add('is-open');
      const trigger = group.querySelector('[data-sgg-model-trigger]');
      if (trigger instanceof HTMLButtonElement) {
        trigger.setAttribute('aria-expanded', 'true');
      }
    }

    groups.forEach((group) => {
      if (!(group instanceof HTMLElement)) return;

      const trigger = group.querySelector('[data-sgg-model-trigger]');
      if (!(trigger instanceof HTMLButtonElement)) return;

      if (group.classList.contains('is-open')) {
        trigger.setAttribute('aria-expanded', 'true');
      }

      trigger.addEventListener('click', () => {
        const isOpen = group.classList.contains('is-open');
        if (isOpen) {
          closeGroup(group);
        } else {
          openGroup(group);
        }
      });

      group.addEventListener('focusout', (event) => {
        const nextFocus = event.relatedTarget;

        if (!(nextFocus instanceof Node) || !group.contains(nextFocus)) {
          closeGroup(group);
        }
      });
    });

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      groups.forEach((group) => {
        if (!group.contains(target)) {
          closeGroup(group);
        }
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      groups.forEach((group) => closeGroup(group));
    });
  }

  function initCollectionFitFiltering() {
    const params = getFitParams();
    syncFitFilterLinks();

    document.querySelectorAll('[data-sgg-collection-root]').forEach((root) => {
      const cards = Array.from(root.querySelectorAll('[data-sgg-product-card]'));
      const countNode = root.querySelector('[data-sgg-results-count]');
      const activeFilters = root.querySelector('[data-sgg-fit-active-filters]');
      const emptyState = root.querySelector('[data-sgg-empty-state]');
      const pagination = root.querySelector('[data-sgg-pagination]');
      const emptyStateClear = root.querySelector('[data-sgg-clear-fit-link]');

      renderFitFilterSummary(activeFilters, params);

      if (emptyStateClear instanceof HTMLAnchorElement) {
        const clearUrl = new URL(window.location.href);
        clearUrl.searchParams.delete('brand');
        clearUrl.searchParams.delete('model');
        emptyStateClear.href = `${clearUrl.pathname}${clearUrl.search}${clearUrl.hash}`;
      }

      if (!cards.length) {
        updateResultsLabel(countNode, 0, params);
        return;
      }

      let visibleCount = 0;

      cards.forEach((card) => {
        if (!(card instanceof HTMLElement)) return;

        const brands = readCsv(card.dataset.sggBrandKeys);
        const models = readCsv(card.dataset.sggModelKeys);
        const universal = card.dataset.sggUniversal === 'true';

        const matchesBrand = !params.brand || brands.includes(params.brand);
        const matchesModel =
          !params.model || models.includes(params.model) || (universal && matchesBrand);
        const isVisible = matchesBrand && matchesModel;

        card.hidden = !isVisible;
        card.classList.toggle('is-hidden', !isVisible);

        if (isVisible) {
          visibleCount += 1;
        }
      });

      updateResultsLabel(countNode, visibleCount, params);

      if (emptyState instanceof HTMLElement) {
        emptyState.hidden = visibleCount > 0 || (!params.brand && !params.model);
      }

      if (pagination instanceof HTMLElement) {
        pagination.hidden = Boolean(params.brand || params.model);
      }
    });
  }

  function initProductPage() {
    document.querySelectorAll('[data-sgg-product-root]').forEach((root) => {
      const variantsNode = root.querySelector('[data-sgg-variants-json]');
      const form = root.querySelector('[data-sgg-product-form]');
      const variantInput = root.querySelector('[data-sgg-variant-id]');
      const priceNode = root.querySelector('[data-sgg-price]');
      const submitButton = root.querySelector('[data-sgg-submit]');
      const stickyBar = root.querySelector('[data-sgg-sticky-bar]');
      const stickyPrice = root.querySelector('[data-sgg-sticky-price]');
      const stickyVariant = root.querySelector('[data-sgg-sticky-variant]');
      const stickySubmit = root.querySelector('[data-sgg-sticky-submit]');
      const mainImage = root.querySelector('[data-sgg-main-image]');
      const thumbButtons = root.querySelectorAll('[data-sgg-thumb]');
      const optionButtons = root.querySelectorAll('[data-sgg-option-button]');
      const qtyInput = root.querySelector('[data-sgg-qty-input]');

      if (!(variantsNode instanceof HTMLScriptElement) || !(form instanceof HTMLFormElement)) return;

      let variants = [];

      try {
        variants = JSON.parse(variantsNode.textContent || '[]');
      } catch (error) {
        variants = [];
      }

      const selected = [];
      root.querySelectorAll('[data-sgg-selected-label]').forEach((label) => {
        const position = Number(label.getAttribute('data-sgg-selected-label')) - 1;
        selected[position] = label.textContent?.trim() || '';
      });

      function setActiveThumb(mediaId) {
        thumbButtons.forEach((button) => {
          button.classList.toggle('is-active', button.getAttribute('data-media-id') === String(mediaId));
        });
      }

      function updateMainImage(src, alt, mediaId) {
        if (!(mainImage instanceof HTMLImageElement) || !src) return;

        mainImage.src = src;
        mainImage.alt = alt || mainImage.alt;

        if (mediaId) {
          setActiveThumb(mediaId);
        }
      }

      function updateVariant(variant) {
        if (!variant) {
          if (submitButton instanceof HTMLButtonElement) {
            submitButton.disabled = true;
            submitButton.textContent = 'Unavailable';
          }
          return;
        }

        if (variantInput instanceof HTMLInputElement) {
          variantInput.value = String(variant.id);
        }

        if (priceNode) {
          priceNode.textContent = money(variant.price);
        }

        if (stickyPrice) {
          stickyPrice.textContent = money(variant.price);
        }

        if (stickyVariant) {
          stickyVariant.textContent = variant.title || '';
        }

        if (submitButton instanceof HTMLButtonElement) {
          submitButton.disabled = !variant.available;
          submitButton.textContent = variant.available ? `Add to Cart - ${money(variant.price)}` : 'Sold Out';
        }

        if (variant.featured_media_id) {
          const activeThumb = root.querySelector(`[data-sgg-thumb][data-media-id="${variant.featured_media_id}"]`);
          if (activeThumb instanceof HTMLButtonElement) {
            updateMainImage(
              activeThumb.getAttribute('data-media-src'),
              activeThumb.getAttribute('data-media-alt'),
              variant.featured_media_id
            );
          }
        }
      }

      function getCurrentVariant() {
        return variants.find((variant) =>
          variant.options.every((value, index) => !value || value === selected[index])
        );
      }

      optionButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const position = Number(button.getAttribute('data-position')) - 1;
          const value = button.getAttribute('data-value') || '';

          selected[position] = value;

          optionButtons.forEach((candidate) => {
            const candidatePosition = Number(candidate.getAttribute('data-position')) - 1;
            if (candidatePosition === position) {
              candidate.classList.toggle('is-active', candidate === button);
            }
          });

          const label = root.querySelector(`[data-sgg-selected-label="${position + 1}"]`);
          if (label) {
            label.textContent = value;
          }

          updateVariant(getCurrentVariant());
        });
      });

      thumbButtons.forEach((button) => {
        button.addEventListener('click', () => {
          updateMainImage(
            button.getAttribute('data-media-src'),
            button.getAttribute('data-media-alt'),
            button.getAttribute('data-media-id')
          );
        });
      });

      root.querySelectorAll('[data-sgg-qty-change]').forEach((button) => {
        button.addEventListener('click', () => {
          if (!(qtyInput instanceof HTMLInputElement)) return;

          const step = Number(button.getAttribute('data-sgg-qty-change')) || 0;
          const currentValue = Number(qtyInput.value) || 1;
          qtyInput.value = String(Math.max(1, currentValue + step));
        });
      });

      stickySubmit?.addEventListener('click', () => {
        form.requestSubmit();
      });

      if (stickyBar && submitButton instanceof HTMLButtonElement) {
        const toggleSticky = () => {
          const rect = submitButton.getBoundingClientRect();
          const shouldShow = rect.bottom < 0;
          stickyBar.hidden = !shouldShow;
        };

        toggleSticky();
        document.addEventListener('scroll', toggleSticky, { passive: true });
        window.addEventListener('resize', toggleSticky);
      }

      updateVariant(getCurrentVariant());
    });
  }

  function initFitSelection() {
    let pageSelection = null;

    document.querySelectorAll('[data-sgg-collection-root]').forEach((root) => {
      const contextSelection = getCollectionContextSelection(root);

      if (contextSelection) {
        pageSelection = setStoredFitSelection(contextSelection);
      }
    });

    bindFitSelectionTriggers();
    refreshFitUi(pageSelection);
  }

  document.addEventListener('DOMContentLoaded', () => {
    initCollectionControls();
    initModelRail();
    initCollectionFitFiltering();
    initProductPage();
    initFitSelection();
  });
})();
